import { SortableContainer } from 'react-sortable-hoc';

import { DropDownContent } from './DropDownContent';

export const SortableDropDownContent = SortableContainer(DropDownContent);
